import "./Common.css";
import { useState, useContext, memo } from "react";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Crash from "../Games/Crash/Crash";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { setConversionRates } from "../../store/game";
import Spinner from "../Common/Modals/Spinner";
import SpinSignup from "./Modals/SignupSpin";
import UserFeedback from "./UserFeedback";
import ConversionRatesAPI from "../../api/conversion_rate";
import { betPriceContext } from "../Contexts/BetPrice";
import useWindowDimensions from "../Contexts/windowDimensions";
import { modalsControl } from "../Contexts/ModalsControl";
import Alert from "./Alert";
import ResetPassword from "./Modals/ResetPassword";
import VerifyEmail from "./Modals/VerifyEmail";
import MobileTrendsOpener from "./Additional/MobileTrendsOpener";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import ReferalBeforeLogin from "../Pages/ReferalBeforeLogin";
import ReferralManagement from "./ReferralManagement";
import Chat from "./Chat/Chat";
import SideBar from "./Sidebar/SideBar";
import MenuIcon from "@mui/icons-material/Menu";
import LanguageIcon from "@mui/icons-material/Language";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Languages from "./Languages/Languages";

import Limbo from "../Games/Limbo/Limbo";

import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import RemoveIcon from "@mui/icons-material/Remove";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Common = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.user.currentUser);

  // const game_state = useSelector((state) => state.game.game_state);

  const { insuficientWallet } = useContext(betPriceContext);
  const {
    spinWheel,
    referalLinkModal,
    setReferalLinkModal,
    setSignInOpen,
    setSpinWheel,
    setGettingRate,
  } = useContext(modalsControl);

  const { t, i18n } = useTranslation();
  const { height, width } = useWindowDimensions();
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.pathname == "/") {
      navigate("/crash");
    }
  }, []);

  const [second, setSecond] = useState(0);
  useEffect(() => {
    if (second >= 180) {
      setSecond(0);
    } else {
      setTimeout(() => {
        setSecond(second + 1);
      }, 1000);
    }
  }, [second]);

  let [once, setOnce] = useState(true);

  useEffect(() => {
    if (once || second > 179) {
      setGettingRate(true);
      ConversionRatesAPI.get_conversion_rates().then((response) => {
        setGettingRate(false);
        dispatch(
          setConversionRates({
            conversion_rates: response.data,
          })
        );
      });
      setOnce(false);
    }
  }, [currentUser, second]);

  const [sidebarBox, setsidebarBox] = useState(false);
  const opensidebarBox = () => {
    sidebarBox ? setsidebarBox(false) : setsidebarBox(true);
  };
  const [showPromotions, setshowPromotions] = useState(false);
  const [liveSupport, setLiveSupport] = useState(false);
  const [show, setShow] = useState(false);
  const [chatBox, setChatBox] = useState(false);
  const [languageSelector, setLanguageSelector] = useState(false);
  const handleLanguageSelector = () => {
    setLanguageSelector(!languageSelector);
  };
  const openChatBox = () => {
    chatBox ? setChatBox(false) : setChatBox(true);
  };

  const handleReferEarn = () => {
    if (!currentUser) {
      setSignInOpen(true);
      return;
    }
    navigate("/referal-management/referal-dashboard");
    setReferalLinkModal(true);
  };

  const handleNavigate = () => {
    navigate("/crash");
    setsidebarBox(false);
  };

  const handleSpinOpen = () => {
    if (!currentUser) {
      setSignInOpen(true);
      return;
    }
    setSpinWheel(true);
  };

  const handleLiveSupport = () => {
    setLiveSupport(!liveSupport);
  };
  return (
    <div
      style={{
        overflow: "none",
      }}
      className="top-level-parent relative my_row"
    >
      <div
        className={`sideBar-container width-5 fixed height ${
          sidebarBox ? "hidden-bar mobile-hidden-bar" : "shown-bar"
        } ${chatBox && "mobile-hidden-bar"} `}
      >
        <SideBar
          chatBox={chatBox}
          setChatBox={setChatBox}
          setsidebarBox={setsidebarBox}
          sidebarBox={sidebarBox}
          setLanguageSelector={setLanguageSelector}
          handleReferEarn={handleReferEarn}
          handleSpinOpen={handleSpinOpen}
        />
      </div>
      <div
        style={{
          position: "relative",
          overflow: "auto",
        }}
        className="top-level-div width-95 height"
      >
        <div
          style={{
            position: "sticky",
            top: "0",
            zIndex: "20",
          }}
          className="common-header-container"
        >
          <VerifyEmail />
          <ResetPassword />

          {spinWheel && <Spinner />}
          {!currentUser && <SpinSignup />}

          <Header
            onClick={openChatBox}
            sidebaropen={opensidebarBox}
            handleReferEarn={handleReferEarn}
          />
        </div>
        <div
          style={{
            transition: ".5s",
          }}
          className={`common-component-main-div justified ${
            chatBox && width >= 767
              ? "width"
              : chatBox && width <= 767
              ? "none"
              : "width"
          }`}
        >
          <div className="common-component-inner-div page-width">
            <div className="common-component-content-div relative">
              <div
                style={{
                  position: "fixed",
                  zIndex: "22",
                  left: "0",
                  background: "orange",
                  opacity: insuficientWallet ? "100%" : "0%",
                  left: insuficientWallet ? "0px" : "-375px",
                  transition: ".3s",
                }}
                className="insuficient-amount-alert-container"
              >
                <Alert
                  type="warning"
                  message="Insuficient balance - Please recharge your wallet"
                />
              </div>

              <div
                className="trends-chat-on-mobile"
                style={{
                  display: "none",
                }}
              >
                <MobileTrendsOpener />
              </div>

              {/* Common routing elements  */}
              <div className="common-game-container">
                <Routes>
                  <Route
                    // path="/game/crash"
                    path="/:referalLink"
                    element={<Crash chatBox={chatBox} />}
                  ></Route>
                  {/* <Route
                    // path="/game/crash"
                    path="/casino/limbo"
                    element={<Limbo chatBox={chatBox} />}
                  ></Route> */}
                  <Route path="/" element={<Crash />}></Route>
                  <Route
                    path="/referal-management/:pathname"
                    element={
                      currentUser ? (
                        <ReferralManagement />
                      ) : (
                        <ReferalBeforeLogin />
                      )
                    }
                  ></Route>

                  {/* <Route path="/" element={<ReferalBeforeLogin />}></Route> */}
                </Routes>
              </div>
              {/* Common routing ends here  */}

              {/* Common footer starts here  */}
              <div className="user-feedBack-section">
                <div
                  style={{
                    marginBottom: "30px",
                    background: "#282a30",
                    borderRadius: "5px",
                  }}
                  className="userFeedbackInner-container"
                >
                  <UserFeedback />
                </div>
              </div>
              {/* Common footer ends here */}
              <div
                style={{
                  padding: "0 40px",
                  marginBottom: "40px",
                }}
                className="common-footer-container"
              >
                <div
                  style={{
                    marginTop: "30px",
                  }}
                ></div>
                <Footer />
              </div>
            </div>
          </div>
        </div>
        <div
          className="chat-main-box"
          style={{
            width:
              chatBox && width >= 767
                ? "350px"
                : chatBox && width <= 767
                ? "100%"
                : "0%",
            opacity: chatBox ? "100%" : "0",
            position: "fixed",
            top: "68px",
            right: chatBox ? "0px" : "-272px",
            transition: ".3s",
            zIndex: "99",
            height: "100vh",
            background: "#24262b",
          }}
        >
          {chatBox && <Chat openChatBox={openChatBox} />}
        </div>
        <div
          className={
            sidebarBox === true
              ? "affiliate-side-pannel"
              : "affiliate-side-pannel"
          }
          style={{
            width:
              sidebarBox && width >= 767
                ? "270px"
                : sidebarBox && width <= 767
                ? "100%"
                : "0%",
            opacity: sidebarBox ? "100%" : "0",
            position: "fixed",
            top: "0",
            left: sidebarBox ? "0px" : "-272px",
            transition: ".3s",
            zIndex: "99",
            height: "100vh",
          }}
        >
          <div
            style={{
              backgroundColor: "#101010",
              border: ".5px solid #2d9fc659",
              zIndex: "1",
            }}
            className={`side-bar-languages-container width absolute ${
              languageSelector
                ? "shown-language-selector"
                : "hidden-language-selector"
            }`}
          >
            <div
              style={{
                borderBottom: "1px solid #2d9fc659",
                padding: "15px",
                backgroundColor: "#191a1d",
              }}
              className="language-top-container width centered_text"
            >
              <span className="white bold">Languages</span>
            </div>

            <div className="side-bar-languages width white">
              <Languages setLanguageSelector={setLanguageSelector} />
            </div>
          </div>
          <div className="affiliate-side-pannel-content">
            <a
              className="close-icon pointer"
              onClick={opensidebarBox}
              style={{ top: "21px" }}
            >
              <img src="/imgs/close-icon.svg" />
            </a>
            <div className="logo-hamburger-container pointer my_row center_aligns space-between">
              <div className="side-bar-open-icon-container justified">
                <button
                  className="text_color sidebar-action-button"
                  onClick={opensidebarBox}
                >
                  <MenuIcon />
                </button>
              </div>
              <div className="sideBarMenu-logo-container width-75">
                <img
                  src="/imgs/logo/logo.png"
                  alt=""
                  onClick={handleNavigate}
                />
              </div>
            </div>

            <div
              style={{
                background: "#101010",
                padding: "10px",
                marginTop: "25px",
                borderRadius: "5px",
              }}
              className="side-bar-expand-spin-container pointer"
              onClick={handleSpinOpen}
            >
              <div className="side-bar-expand-spin-top-container width">
                <span className="bold" style={{ color: "#FFBF39" }}>
                  {t("header.referral.vip")}
                </span>
              </div>
              <div
                style={{
                  marginTop: "10px",
                }}
                className="expanded-spin-time-container my_row"
              >
                <div className="expanded-spin-img-container width-20 my_row center_align">
                  <img src="/imgs/infiniteSpin.webp" alt="Spin Wheel" />
                </div>
                <div className="expanded-spin-time-container width-80">
                  <div className="next-spin-time width">
                    <span className="bold">{t("header.referral.earn")}</span>
                  </div>
                  <div className="next-spin-text width">
                    <span
                      style={{
                        fontSize: "10px",
                      }}
                      className="width text_color"
                    >
                      {t("header.referral.free")}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: "7px",
              }}
              className="refer-&-earn-side-bar-menu pointer"
            >
              <button
                style={{
                  backgroundColor: "#101010",
                  borderRadius: "5px",
                }}
                className="refer-earn-img-text-container width my_row center_align pointer"
                onClick={handleReferEarn}
              >
                <img
                  style={{
                    maxWidth: "25%",
                  }}
                  src="/imgs/refer.webp"
                  alt="refer & earn"
                />
                <span className="white bold">
                  {t("header.referral.rerearn")}
                </span>
              </button>
            </div>

            <div className="affiliate-accordion js-acc-single">
              <div
                className={`affiliate-accordion-item js-acc-item ${
                  show && "is-open"
                }`}
              >
                <h2
                  onClick={() => setShow(!show)}
                  className="affiliate-accordion-title js-acc-single-trigger"
                >
                  <img
                    src="/imgs/casino.svg"
                    alt="casino"
                    style={{ maxWidth: "21px", maxHeight: "23px" }}
                  />
                  &nbsp; {t("header.referral.Casno")}
                </h2>
                {show ? (
                  <div className="affiliate-accordion-content">
                    <ul className="affiliate-left-pannel-menu">
                      <li>
                        <a>
                          <img
                            src="/imgs/bcw-originals.svg"
                            alt=""
                            className="width-auto"
                          />
                          {t("header.referral.BCWOriginals")}
                          <img
                            src="/imgs/affiliate-right-arrow.svg"
                            alt=""
                            className="width-auto affiliate-dropdown-menu-arrow"
                          />
                        </a>
                        <ul>
                          <li>
                            <button onClick={opensidebarBox}>
                              <Link to="/crash">
                                <img
                                  src="/imgs/crashLogo.webp"
                                  alt=""
                                  className="width-auto"
                                />
                                {t("header.referral.Crash")}
                              </Link>
                            </button>
                          </li>
                          {/* <li>
                            <button onClick={opensidebarBox}>
                              <Link to="/casino/limbo">
                                <img
                                  src="/imgs/limboLogo.webp"
                                  alt=""
                                  className="width-auto"
                                />
                                Limbo
                              </Link>
                            </button>
                          </li> */}
                        </ul>
                      </li>
                    </ul>
                  </div>
                ) : null}
              </div>
              <div
                className={`affiliate-accordion-item js-acc-item ${
                  showPromotions && "is-open"
                }`}
              >
                <h2
                  className="affiliate-accordion-title js-acc-single-trigger"
                  onClick={() => setshowPromotions(!showPromotions)}
                >
                  <img
                    src="/imgs/Promotions.svg"
                    alt="Promotions"
                    style={{ maxWidth: "24px", maxHeight: "21px" }}
                  />
                  &nbsp; {t("header.referral.Promo")}
                </h2>
                {showPromotions ? (
                  <div className="affiliate-accordion-content">
                    <ul className="affiliate-left-pannel-menu">
                      <li>
                        <button onClick={opensidebarBox}>
                          <Link to="/referal-management/referal-dashboard">
                            <img
                              src="/imgs/affiliate-icon.svg"
                              alt=""
                              className="width-auto"
                            />
                            {t("header.referral.Affiliate")}
                          </Link>
                        </button>
                      </li>
                      {/* <li>
                      <a href="#">
                        <img
                          src="/imgs/blogs-icon.svg"
                          alt=""
                          className="width-auto"
                        />
                        Blogs
                      </a>
                    </li> */}
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="side-bar-language-selector-main">
              <div className="side-bar-language-selector-inner">
                <button
                  style={{
                    backgroundColor: "rgb(16, 16, 16)",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                  className="side-bar-language-selector-content width justified white"
                  onClick={handleLanguageSelector}
                >
                  <div className="language-selector-icon-container text_color">
                    <LanguageIcon />
                  </div>
                  <div
                    style={{
                      margin: "0 8px",
                      borderRadius: "5px",
                    }}
                    className="language-selector-name-container"
                  >
                    {i18n.resolvedLanguage}
                  </div>
                  <div
                    className={`language-selector-arrow-container text_color ${
                      languageSelector && "rotate-icon"
                    }`}
                  >
                    <KeyboardArrowDownIcon />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="live-support-main fixed">
        <div className="live-support-inner">
          <div className="live-support-button-container">
            {liveSupport ? (
              <div className="live-support-chat-box-main">
                <div className="live-support-inner-box">
                  <div className="live-support-content-box">
                    <div className="live-support-header width my_row space-between white">
                      <span className="bold live-support">Live Support</span>
                      <button
                        className="white bold"
                        onClick={handleLiveSupport}
                      >
                        <RemoveIcon />
                      </button>
                    </div>
                    <div className="live-support-body width height justified">
                      <a
                        href="https://api.whatsapp.com/message/JUDYEPU7E6FGE1?autoload=1&app_absent=0"
                        className="width-50 gc justified column"
                        target="_blank"
                      >
                        <WhatsAppIcon className="width" />
                        <span>Janis Tu</span>
                      </a>
                      <a
                        className="width-50 gc justified column"
                        href="https://api.whatsapp.com/message/JETL6LRAY2C7P1?autoload=1&app_absent=0"
                        target="_blank"
                      >
                        <WhatsAppIcon />
                        <span>Ansuya Ki</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <button
                className="live-support-button white"
                onClick={handleLiveSupport}
              >
                <HeadsetMicIcon />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(Common);
